import * as getters from './getters'
import * as actions from './actions'
import mutations from './mutations'

export default {
  namespaced: true,
  state: {
    tempData: null,
    temp_vwcd2plmd00100: [],
    temp_vwcd2plmd00101: [],
    temp_vwcd2plmd00102: []
  },
  mutations: mutations,
  actions: actions,
  getters: getters
}
